import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import AboutHeroSection from './components/AboutHeroSection';
import MissionSection from './components/MissionSection';
import HistorySection from './components/HistorySection';
import LeadershipSection from './components/LeadershipSection';
import ValuesSection from './components/ValuesSection';
import ImpactSection from './components/ImpactSection';

export default function About() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <AboutHeroSection />
        <MissionSection />
        <ValuesSection />
        <HistorySection />
        <LeadershipSection />
        <ImpactSection />
      </main>
      <Footer />
    </div>
  );
}